import { el } from './dom.js';

/**
 * A small centered modal with one or more choices. Resolves to the chosen
 * option's `key`, or `null` if dismissed (backdrop, Escape, or a choice
 * whose key is null).
 *
 *   const pick = await chooseDialog({
 *     title: 'Import save',
 *     body: '84 seen, 40 caught.',
 *     choices: [
 *       { key: 'merge', label: 'Add to my Pokédex' },
 *       { key: 'replace', label: 'Replace mine', class: 'button--danger' },
 *       { key: null, label: 'Cancel', class: 'button--ghost' },
 *     ],
 *   });
 */
export function chooseDialog({ title, body, choices }) {
  return new Promise((resolve) => {
    const backdrop = el('div', {
      class: 'sheet-backdrop dialog-backdrop is-open',
      onclick: (e) => {
        if (e.target === backdrop) done(null);
      },
    });
    const panel = el(
      'div',
      { class: 'dialog', role: 'dialog', 'aria-modal': 'true' },
      el('h2', { class: 'dialog__title' }, title),
      body ? el('p', { class: 'dialog__body' }, body) : null,
      el(
        'div',
        { class: 'dialog__actions' },
        ...choices.map((c) =>
          el(
            'button',
            {
              class: `button ${c.class || ''}`.trim(),
              type: 'button',
              onclick: () => done(c.key ?? null),
            },
            c.label,
          ),
        ),
      ),
    );
    const onKey = (e) => {
      if (e.key === 'Escape') done(null);
    };
    function done(key) {
      document.removeEventListener('keydown', onKey);
      backdrop.remove();
      resolve(key);
    }
    backdrop.append(panel);
    document.body.append(backdrop);
    document.addEventListener('keydown', onKey);
    requestAnimationFrame(() => panel.querySelector('.button')?.focus());
  });
}
